import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralListMyCoach = styled.div`
  display: grid;
  margin-top: 1em;
`;

export const ImageCoach = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 99px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-image: url(${(props) => props.previewImage ? props.previewImage : props.defaultCoachPhoto});
`;

export const TitleOfList = styled.p`
  font-size: 20px;
  font-weight: 500;
  margin-left: 1.5em;
`;

export const CoachTitle = styled.p`
  font-weight: normal;
  color: #1c1c1c;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  font-size: 18px;
`;

export const CoachDescription = styled.p`
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  font-size: 12px;
  display: flex;
  align-items: center;
`;

export const DateDescription = styled.p`
  background-color: ${({ theme }) => theme.secondaryGrayLightFour};
  padding: 0.5em 0.5em 0.5em 0.7em;
  color: ${({ theme }) => theme.secondaryDarkOne};
  font-size: 12px;
  margin-top: 1em;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const AvailabilityAndViewButton = styled.p`
  color: #989898;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonViewAvailability = styled.div`
  float: left;
  color: ${({ theme }) => theme.primary.purple};
  cursor: pointer;
  font-weight: 400;
  font-size: 13px;
  :hover {
    color: ${({ theme }) => theme.primary.purple};
  }
`;

export const ButtonViewDetails = styled.div`
  float: right;
  color: ${({ theme }) => theme.primary.purple};
  cursor: pointer;
  font-weight: bold;
  :hover {
    color: #4e4e4e;
  }
`;

export const ContentDescriptLang = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
`;

export const useStyles = makeStyles(() => ({
  cardCoach: {
    marginBottom: 20,
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: theme.neutral.white,
    borderTopColor: "#FF52AB",
    border: `1px solid ${theme.neutral.gray[400]}`,
    boxSizing: "border-box",
    borderRadius: "0px 0px 4px 4px",
    maxWidth: "350px",
    height: "209.7px",
  },
  iconCalendar: {
    color: theme.button.primary,
    width: "0.6em",
    marginBottom: "0.1em",
  },
}));
